import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const BadgesLazy = loadable(() => import(/* webpackChunkName: "Badges" */ './BadgesSuspense'));

export const BadgesAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <BadgesLazy />
    </DelayedSuspense>
);
